module.exports = __webpack_public_path__ + "static/media/piedade.1431255c.webp";